import posthog from 'posthog-js';

if (import.meta.env.VITE_IS_LOCALHOST) {
  /* eslint-disable no-console -- localhost stub routes every capture to the console */
  posthog.capture = ((event: string, props?: unknown) =>
    console.log('[posthog]', event, props)) as typeof posthog.capture;
  posthog.identify = (distinctId: string, props?: unknown) =>
    console.log('[posthog identify]', distinctId, props);
  posthog.reset = () => console.log('[posthog reset]');
  posthog.setPersonProperties = (props: unknown) =>
    console.log('[posthog setPersonProperties]', props);
  /* eslint-enable no-console -- end of the localhost stub */
} else {
  // Key is deliberately hardcoded — it's the public phc_ client key, designed
  // to ship in the browser bundle. An env-var here breaks the CI/Docker build
  // (.env is untracked, so import.meta.env resolves to undefined in prod).
  posthog.init('phc_pwnCbnL8tfd5HhfjxdETqwPbPgFUN3Xu4LndZaJWB3Ax', {
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',
    autocapture: false,
    disable_session_recording: true,
    capture_pageview: 'history_change',
    capture_performance: { web_vitals: true, network_timing: false },
    person_profiles: 'identified_only',
  });
  posthog.register({
    release: window.RELEASE,
  });
}

export default posthog;
